export default __webpack_public_path__ + "images/assets/c04d26c901ba7723c8a85be62d655341.svg";